<div class="container">
  <ng-container *ngIf="hasAnyChange()">
    <span class="filter-title">Filter: </span>
    <!-- Regions pill -->
    <span *ngIf="isFilterApplied('regions')" class="pill">
      Regions/{{ filterData.regions.join(",") }}
      <button
        type="button"
        (click)="clearFilter('regions')"
        aria-label="Clear regions filter"
      >
        X
      </button>
    </span>
    <!-- Markets pill -->
    <span *ngIf="isFilterApplied('markets')" class="pill">
      Markets/{{ filterData.markets.join(",") }}
      <button
        type="button"
        (click)="clearFilter('markets')"
        aria-label="Clear markets filter"
      >
        X
      </button>
    </span>
    <!-- Date range pill -->
    <span *ngIf="isFilterApplied('date_range')" class="pill">
      Date range/{{ filterData.start_month }} - {{ filterData.end_month }}
      <button
        type="button"
        (click)="clearDateFilters()"
        aria-label="Clear date range filter"
      >
        X
      </button>
    </span>
  </ng-container>
</div>
